module.exports = __webpack_public_path__ + "media/images/background/background-dna-digital-47b28ae36c97b4caefbc7be73bba1084.svg";